import ActionTypes from "./ActionTypes";
import Dispatcher from "./Dispatcher";

export default {
  search(query) {
    Dispatcher.dispatch({
      actionType: ActionTypes.SEARCH_STORE_SEARCH,
      query,
    });
  }
}
